var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"logo_rect","width":"48","height":"48","key":0}),React.createElement("path",{"d":"M27.9981 33.8847V26.0556H19.9043V33.8847H14.8789V14.3984H19.9043V21.6741H27.9969V14.3984H33.0212V33.8847H27.9981Z","fill":"#fff","key":1})]);
}

Logo.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","role":"img"};

module.exports = Logo;

Logo.default = Logo;
